import type { BaseSearchParamsWithoutQuery } from 'algoliasearch/lite';

import { useMemo } from 'react';

import { useAlgoliaRuleContexts } from './useAlgoliaRuleContexts';
import { useAppContext } from '~/utilities/context/static/AppContext';

const TEST_LOCALES = ['nl_nl', 'de_de', 'en_us'];
const PREMIUM_SEGMENT = 'premium';
const PREMIUM_ANALYTICS_TAG = 'premium';

export type AlgoliaABTestConfig = Pick<
  BaseSearchParamsWithoutQuery,
  'enableABTest' | 'analyticsTags'
>;

export const useAlgoliaABTestConfig = (): AlgoliaABTestConfig => {
  const { locale } = useAppContext();
  const { ruleContexts } = useAlgoliaRuleContexts();

  const config = useMemo<AlgoliaABTestConfig>(() => {
    const isTestLocale = TEST_LOCALES.includes(locale);

    if (!isTestLocale) {
      return {
        enableABTest: undefined,
        analyticsTags: undefined,
      };
    }

    const isPremiumUser = ruleContexts?.some(context => context.toLowerCase() === PREMIUM_SEGMENT);

    if (isPremiumUser) {
      return {
        enableABTest: true,
        analyticsTags: [PREMIUM_ANALYTICS_TAG],
      };
    }

    return {
      enableABTest: false,
      analyticsTags: undefined,
    };
  }, [locale, ruleContexts]);

  return config;
};
